var map = {
	"./Event": [
		12,
		0,
		1,
		24
	],
	"./Event.js": [
		12,
		0,
		1,
		24
	],
	"./Events": [
		13,
		0,
		1,
		4
	],
	"./Events.js": [
		13,
		0,
		1,
		4
	],
	"./GiftCard": [
		14,
		0,
		1,
		25
	],
	"./GiftCard.js": [
		14,
		0,
		1,
		25
	],
	"./Home": [
		15,
		0,
		1,
		26
	],
	"./Home.js": [
		15,
		0,
		1,
		26
	],
	"./IframePage": [
		16,
		0,
		1,
		6
	],
	"./IframePage.js": [
		16,
		0,
		1,
		6
	],
	"./Location": [
		17,
		0,
		1,
		27
	],
	"./Location.js": [
		17,
		0,
		1,
		27
	],
	"./Menu": [
		18,
		0,
		1,
		7
	],
	"./Menu.js": [
		18,
		0,
		1,
		7
	],
	"./News": [
		20,
		0,
		1,
		5
	],
	"./News.js": [
		20,
		0,
		1,
		5
	],
	"./Showcase": [
		21,
		0,
		2,
		28,
		1,
		3
	],
	"./Showcase.js": [
		21,
		0,
		2,
		28,
		1,
		3
	],
	"./TakeAway": [
		19,
		0,
		1,
		8
	],
	"./TakeAway.js": [
		19,
		0,
		1,
		8
	],
	"./base": [
		11,
		0,
		1
	],
	"./base.js": [
		11,
		0,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 41;
module.exports = webpackAsyncContext;